import React from 'react';
import { aboutData, careersData } from '../data/mock';
import { Award, Users, Target, ArrowRight } from 'lucide-react';

const AboutSection = () => {
  return (
    <section id="about" className="py-24 md:py-32 bg-[#1A2B3C]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          {/* Quality Standards */}
          <div>
            <div className="flex items-center gap-4 mb-6">
              <div className="w-12 h-px bg-[#D4AF37]" />
              <span className="font-lato text-[#D4AF37] uppercase tracking-[0.2em] text-xs">Our Philosophy</span>
            </div>

            <h2 className="font-playfair text-4xl text-white mb-6">
              {aboutData.headline}
            </h2>

            <div className="font-lato text-white/70 leading-relaxed mb-8 space-y-4">
              {aboutData.body.map((paragraph, i) => (
                <p key={i}>{paragraph}</p>
              ))}
            </div>

            {/* Trust Indicators */}
            <div className="grid grid-cols-2 gap-4">
              <div className="p-5 rounded-lg bg-white/5 border border-[#D4AF37]/20">
                <Award className="w-8 h-8 text-[#D4AF37] mb-3" />
                <h4 className="font-playfair text-white text-lg mb-1">Excellence Framework</h4>
                <p className="font-lato text-white/50 text-sm">Commissioned for outstanding care</p>
              </div>
              <div className="p-5 rounded-lg bg-white/5 border border-[#D4AF37]/20">
                <Target className="w-8 h-8 text-[#D4AF37] mb-3" />
                <h4 className="font-playfair text-white text-lg mb-1">Rigorous Audits</h4>
                <p className="font-lato text-white/50 text-sm">Exceeding national standards</p>
              </div>
            </div>
          </div>

          {/* Careers */}
          <div className="lg:pl-8">
            <div className="p-8 rounded-xl bg-[#D4AF37] text-[#1A2B3C]">
              <Users className="w-12 h-12 mb-6 opacity-80" />

              <h3 className="font-playfair text-3xl mb-4">
                {careersData.headline}
              </h3>

              <p className="font-lato text-[#1A2B3C]/80 leading-relaxed mb-8">
                {careersData.body}
              </p>

              <button className="flex items-center gap-2 font-lato font-medium hover:gap-4 transition-all duration-300">
                View Open Positions
                <ArrowRight className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
